/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ minutes: NonNullable<unknown> }} Booking_Card_MinInputs */

const en_booking_card_min = /** @type {(inputs: Booking_Card_MinInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.minutes} min`)
};

const es_booking_card_min = /** @type {(inputs: Booking_Card_MinInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.minutes} min`)
};

const de_booking_card_min = /** @type {(inputs: Booking_Card_MinInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.minutes} min`)
};

const zh_booking_card_min = /** @type {(inputs: Booking_Card_MinInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.minutes} 分钟`)
};

const ar_booking_card_min = /** @type {(inputs: Booking_Card_MinInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.minutes} دقيقة`)
};

const fr_booking_card_min = /** @type {(inputs: Booking_Card_MinInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.minutes} min`)
};

const vi_booking_card_min = /** @type {(inputs: Booking_Card_MinInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.minutes} phút`)
};

const sw_booking_card_min = /** @type {(inputs: Booking_Card_MinInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.minutes} min`)
};

const th_booking_card_min = /** @type {(inputs: Booking_Card_MinInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.minutes} นาที`)
};

const bs_booking_card_min = /** @type {(inputs: Booking_Card_MinInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.minutes} min`)
};

const ja_booking_card_min = /** @type {(inputs: Booking_Card_MinInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.minutes} 分`)
};

const ko_booking_card_min = /** @type {(inputs: Booking_Card_MinInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.minutes} 분`)
};

const pt_booking_card_min = /** @type {(inputs: Booking_Card_MinInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.minutes} min`)
};

const it_booking_card_min = /** @type {(inputs: Booking_Card_MinInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.minutes} min`)
};

const sv_booking_card_min = /** @type {(inputs: Booking_Card_MinInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.minutes} min`)
};

const nl_booking_card_min = /** @type {(inputs: Booking_Card_MinInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`min. ${i?.minutes}`)
};

const da_booking_card_min = /** @type {(inputs: Booking_Card_MinInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.minutes} min.`)
};

const nb_booking_card_min = /** @type {(inputs: Booking_Card_MinInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.minutes} min`)
};

const fi_booking_card_min = /** @type {(inputs: Booking_Card_MinInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.minutes} min`)
};

const pl_booking_card_min = /** @type {(inputs: Booking_Card_MinInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.minutes} min`)
};

const ru_booking_card_min = /** @type {(inputs: Booking_Card_MinInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.minutes} мин.`)
};

const tr_booking_card_min = /** @type {(inputs: Booking_Card_MinInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.minutes} min`)
};

const hi_booking_card_min = /** @type {(inputs: Booking_Card_MinInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.minutes} मिनट`)
};

const id_booking_card_min = /** @type {(inputs: Booking_Card_MinInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.minutes} mnt`)
};

const ms_booking_card_min = /** @type {(inputs: Booking_Card_MinInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.minutes} min`)
};

const cs_booking_card_min = /** @type {(inputs: Booking_Card_MinInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.minutes} min.`)
};

const el_booking_card_min = /** @type {(inputs: Booking_Card_MinInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.minutes} λεπτά`)
};

const he_booking_card_min = /** @type {(inputs: Booking_Card_MinInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.minutes}`)
};

const af_booking_card_min = /** @type {(inputs: Booking_Card_MinInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.minutes} min`)
};

const hu_booking_card_min = /** @type {(inputs: Booking_Card_MinInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.minutes} perc`)
};

/**
* | output |
* | --- |
* | "{minutes} min" |
*
* @param {Booking_Card_MinInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const booking_card_min = /** @type {((inputs: Booking_Card_MinInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Booking_Card_MinInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_booking_card_min(inputs)
	if (locale === "de") return de_booking_card_min(inputs)
	if (locale === "zh") return zh_booking_card_min(inputs)
	if (locale === "ar") return ar_booking_card_min(inputs)
	if (locale === "fr") return fr_booking_card_min(inputs)
	if (locale === "vi") return vi_booking_card_min(inputs)
	if (locale === "sw") return sw_booking_card_min(inputs)
	if (locale === "th") return th_booking_card_min(inputs)
	if (locale === "bs") return bs_booking_card_min(inputs)
	if (locale === "ja") return ja_booking_card_min(inputs)
	if (locale === "ko") return ko_booking_card_min(inputs)
	if (locale === "pt") return pt_booking_card_min(inputs)
	if (locale === "it") return it_booking_card_min(inputs)
	if (locale === "sv") return sv_booking_card_min(inputs)
	if (locale === "nl") return nl_booking_card_min(inputs)
	if (locale === "da") return da_booking_card_min(inputs)
	if (locale === "nb") return nb_booking_card_min(inputs)
	if (locale === "fi") return fi_booking_card_min(inputs)
	if (locale === "pl") return pl_booking_card_min(inputs)
	if (locale === "ru") return ru_booking_card_min(inputs)
	if (locale === "tr") return tr_booking_card_min(inputs)
	if (locale === "hi") return hi_booking_card_min(inputs)
	if (locale === "id") return id_booking_card_min(inputs)
	if (locale === "ms") return ms_booking_card_min(inputs)
	if (locale === "cs") return cs_booking_card_min(inputs)
	if (locale === "el") return el_booking_card_min(inputs)
	if (locale === "he") return he_booking_card_min(inputs)
	if (locale === "af") return af_booking_card_min(inputs)
	if (locale === "hu") return hu_booking_card_min(inputs)
	return en_booking_card_min(inputs)
});